import React, {Component} from 'react';
import {Button, Form, Header, Image, Message} from 'semantic-ui-react';
import AccountExpenseContainer from "../../../containers/account_expense_container";
import * as fileIcon from "../../../assets/fileIcon.png";
import Loader from "../../universal/loader";

class UpdateExpense extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true,
            message: undefined,
            showMessage:false
        }
    }

    handleExpenseUpdate = (e) => {
        this.setState({updating:true});
        e.preventDefault();
        const formData = new FormData(e.target);
        this.props.updateExpenseEstimate(formData,this.onSuccessCallBack,this.props.expenseId,this.props.inspectionId);
    };

    onSuccessCallBack = (response) => {
        if(response.success){
            this.setState({showMessage:true});
            setTimeout(()=> {this.props.goBack()},3000)
        }
        this.setState({updating:false});
    };


    render() {
        const expenseDetail = this.props.expenseUpdates;
        return (
            <div style={{width:'50%',margin:'auto'}} className="pad-top">
                {this.state.updating && <Loader save={true}/>}
                <Header content="Update Expenses" textAlign="center"/>
                {this.state.showMessage && <Message positive onDismiss={() =>{this.setState({showMessage:false})}}>
                    <Message.Header>
                        Expense updated successfully!
                    </Message.Header>
                </Message>}
                {expenseDetail  && <Form onSubmit={this.handleExpenseUpdate}>
                    <input type="hidden" name="pipeline_expense_id" value={expenseDetail['id']}/>
                    <Form.Group>
                        <Form.Input
                            label="Agreed Extra Charges"
                            name="aec"
                            required
                            step="0.01"
                            defaultValue={expenseDetail['aec']}
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="aec_attachment"
                        />
                        {expenseDetail['aec_attachment'] && expenseDetail['aec_attachment']['image_path'] && <div className="additional-pad">
                         <Image size="mini" as='a' target="_blank" href={expenseDetail['aec_attachment']['image_path']} src={expenseDetail['aec_attachment'] && expenseDetail['aec_attachment']['content_type'].match(/image/i)?expenseDetail['aec_attachment']['image_path']:fileIcon} />
                        </div>}
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Train Charges"
                            name="train"
                            required
                            step="0.01"
                            defaultValue={expenseDetail['train']}
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="train_attachment"
                        />
                        {expenseDetail['train_attachment'] && expenseDetail['train_attachment']['image_path'] &&  <div className="additional-pad">
                            <Image size="mini" as='a' target="_blank" href={expenseDetail['train_attachment']['image_path']} src={expenseDetail['train_attachment'] && expenseDetail['train_attachment']['content_type'].match(/image/i)?expenseDetail['train_attachment']['image_path']:fileIcon} />
                        </div>}
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Parking Charges"
                            name="parking"
                            required
                            step="0.01"
                            defaultValue={expenseDetail['parking']}
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="parking_attachment"
                        />
                        {expenseDetail['parking_attachment'] && expenseDetail['parking_attachment']['image_path']  && <div className="additional-pad">
                            <Image size="mini" as='a' target="_blank" href={expenseDetail['parking_attachment']['image_path']} src={expenseDetail['parking_attachment'] && expenseDetail['parking_attachment']['content_type'].match(/image/i)?expenseDetail['parking_attachment']['image_path']:fileIcon} />
                        </div>}
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Fuel Charges"
                            name="fuel"
                            required
                            step="0.01"
                            defaultValue={expenseDetail['fuel']}
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="fuel_attachment"
                        />
                        {expenseDetail['fuel_attachment'] && expenseDetail['fuel_attachment']['image_path'] && <div className="additional-pad">
                            <Image size="mini" as='a' target="_blank" href={expenseDetail['fuel_attachment']['image_path']} src={expenseDetail['fuel_attachment'] && expenseDetail['fuel_attachment']['content_type'].match(/image/i)?expenseDetail['fuel_attachment']['image_path']:fileIcon} />
                        </div>}
                    </Form.Group>
                    <Form.TextArea
                        label="Expense Notes"
                        name="notes"
                        defaultValue={expenseDetail['notes']}
                    />
                    <div className="pad-all right-aligned">
                        <Button content = 'Cancel' onClick={() => {this.props.goBack()}} />
                        <Button type="submit" primary content="Update Expense"/>
                    </div>
                </Form>}
            </div>
        )
    }
}

export default AccountExpenseContainer(UpdateExpense)


// WEBPACK FOOTER //
// ./src/views/accounts/expense/update_expense.js